import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AdminViewService {

  userRole:String;
  _isButtonDisabled$ = new BehaviorSubject(false)

  constructor() {
  
   }


   checkAdminVRole():BehaviorSubject<boolean> {

    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this._isButtonDisabled$.next(this.userRole === 'Admin View')
    return this._isButtonDisabled$
   }
}
